<button
  class="w-100 d-grid gap-small radius-plus p-small position-relative border-none container cursor-pointer"
  [style.background-color]="banner()?.backgroundColor"
  (click)="onClick()"
  [id]="'IPO_' + banner()?.symbol + '_WRAPPER'"
>
  <div class="d-flex align-items-center justify-content-center surface-elevated radius-rounded p-small logo-container">
    <app-image
      class="w-100 h-100"
      [imageUrl]="banner()?.logo"
      [defaultImage]="'./wealth-assets/images/default-ipo-banner.png'"
      [needSkeleton]="false"
      [alt]="banner()?.title"
      [id]="'IPO_' + banner()?.symbol + '_IMAGE'"
    />
  </div>

  <div class="text-align-right d-flex flex-wrap align-items-center h-100 align-content-center title-container">
    <p
      class="w-100 st-7 text-onback-high"
      [id]="'IPO_' + banner()?.symbol + '_TITLE'"
    >
      {{ banner()?.title }}
    </p>

    <p
      class="w-100 c-2 text-onback-high"
      [id]="'IPO_' + banner()?.symbol + '_SUB_TITLE'"
    >
      {{ banner()?.subTitle }}
    </p>
  </div>

  <div class="d-flex justify-content-end remaining-container">
    <ngx-badge
      size="md"
      status="neutral"
      mode="fill"
      type="text"
    >
      <ngx-icon
        [iconSize]="'16px'"
        [name]="'calendar'"
        [type]="'linear'"
        class="icon"
      />
      {{ banner()?.remainingTitle }}
    </ngx-badge>
  </div>

  @if (banner()?.backgroundImage) {
    <div class="typography-logo">
      <app-image
        [id]="'IPO_' + banner()?.symbol + '_TYPOGRAPHY'"
        [imageUrl]="banner()?.backgroundImage"
        [defaultImage]="'./wealth-assets/svg/digikala-typography.svg'"
        [alt]="banner()?.title"
      />
    </div>
  }
</button>
